import api from 'services/api';

export const updateComment = async (
  videoHashId: string,
  commentId: string,
  data: { content: string }
): Promise<any> => {
  const response = await api.patch(`/api/videos/comment/${commentId}/`, data);
  return response;
};

export const removeComment = async (commentId: string): Promise<any> => {
  const response = await api.delete(`/api/videos/comment/${commentId}/`);
  return response;
};
